module.exports = __webpack_public_path__ + "img/success.17377451.jpeg";